import { Text, Tooltip, Popup, Link } from 'platform-components';
import { POPUP_DIRECTIONS } from 'platform-components/constants';
import React, { useRef, useCallback, memo } from 'react';
import { useParams } from 'react-router';

interface Props {
    problemsCount: number;
    canEditLesson: boolean;
    handleAddToLesson: (e: React.MouseEvent<HTMLElement>) => void;
}

const ThemePageStackBottomElements = memo((props: Props) => {
    const { problemsCount, canEditLesson, handleAddToLesson } = props;
    const params = useParams<Record<string, string>>();
    const popupRef = useRef<Popup>(null);

    const disabled = Boolean(params?.teamId && !canEditLesson);

    const onMouseEnter = useCallback(() => {
        if (disabled && popupRef.current) {
            popupRef.current.show();
        }
    }, [disabled, popupRef]);

    const onMouseLeave = useCallback(() => {
        if (popupRef.current) {
            popupRef.current.hide();
        }
    }, [popupRef]);

    return (
        <div className="theme-page__stack-controls" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <Link disabled={disabled} mix="theme-page__add-link" onClick={handleAddToLesson} theme={Link.THEME.PRIMARY}>
                <Text id="library.item.addVariantToLesson" weight={Text.WEIGHT.M} />
                <Tooltip
                    onPopupRef={popupRef}
                    popupProps={{ direction: POPUP_DIRECTIONS.TOP, width: 174, offsetLeft: 87, offsetTop: 12 }}
                    theme={Tooltip.THEME.LIGHT_ROUNDED}
                >
                    <span className="theme-page__tooltip-text">
                        <Text id="library.item.studentsStarted" size={Text.SIZE.S} />
                    </span>
                </Tooltip>
            </Link>
            <div className="theme-page__variants-count">
                <Text
                    id="library.item.addedVariantsAmount"
                    size={Text.SIZE.S}
                    values={{ defaultVariant: 1, count: problemsCount }}
                    weight={Text.WEIGHT.M}
                />
            </div>
        </div>
    );
});

export default ThemePageStackBottomElements;
